export const AUDIT_STORE_ID_PARAM = 'aud_store_id';
export const AUDIT_STATUS_PARAM = 'aud_status';
export const AUDIT_REPORT_TYPE_PARAM = 'aud_report_type';
export const AUDIT_DATE_FROM_PARAM = 'aud_date_from';
export const AUDIT_DATE_TO_PARAM = 'aud_date_to';
export const AUDIT_AGE_DAYS_PARAM = 'aud_age_days';
export const AUDIT_PAGE_PARAM = 'aud_page';
export const AUDIT_SIZE_PARAM = 'aud_size';
export const AUDIT_SORT_BY_PARAM = 'aud_sort_by';
export const AUDIT_SORT_ORDER_PARAM = 'aud_sort_order';
